import axios from 'axios';


// const backendUrl = 'http://localhost:21469'
// const backendUrl = 'http://192.168.0.134:21469' // teste dev pra acessar com aparelho externo
// const backendUrl = 'http://192.168.0.18:21458'
// const backendUrl = 'http://192.168.0.194:21469'
// const backendUrl = 'https://apps.delphus.inf.br:22470'  // backend homologação
var backendUrl = 'https://apps2.delphus.inf.br:21470'  //backend produção

// if(window.location.origin == 'http://localhost:3000') {
//     backendUrl = 'http://localhost:21469'
// } else if(window.location.origin == 'https://apps.delphus.inf.br'){
//     backendUrl = 'https://apps.delphus.inf.br:22470'
// }


const auth = JSON.parse(localStorage.getItem('authtarento')) || null

const api = axios.create({
    baseURL: backendUrl + `/api/`
});

api.interceptors.request.use(function (config) {
    var token = ''
    if (auth) {
        token = auth.access_token
    }
    console.log(config)
    config.headers.token =  token;
     
    return config;
});


api.getComboData = async (table, parameter) => {
    return new Promise(async (resolve, reject) => {
        console.log('Searching for parameter ' + parameter)
        await api.get('/' + table + '/combo' + (parameter ? '/' + parameter : '')).then(async r => {
            console.log(r.data)
            resolve(r.data)
        })
    })
}

api.getComboDataWhere = async (table, where) => {
    return new Promise(async (resolve, reject) => {
        console.log('/' + table + '/combo' + where)
        await api.get('/' + table + '/combo' + where).then(async r => {
            resolve(r.data)
        })
    })
}

api.getComboDataAsync = async (table, setCombo, parameter) => {
    return new Promise(async (resolve, reject) => {
        console.log('Searching for parameter ' + parameter)
        await api.get('/' + table + '/combo' + (parameter ? '/' + parameter : '')).then(async r => {
            console.log(r.data)
            resolve(setCombo(r.data))
        })
    })
}

api.getAcessos = async (tela, opcao) => {
    return new Promise(async (resolve, reject) => {
        // console.log('Searching for parameter '+tela+' '+opcao)
        let auth = JSON.parse(localStorage['authtarento']);

        await api.get('/grupo_usuarios/permissoes?tela=' + tela + '&pk_usu=' + auth.user + '&acao=' + opcao).then(async r => {
            if (opcao === 'Consulta') {
                try {
                    resolve(r.data[0].Consulta)
                }
                catch { resolve('N') }
            }

            if (opcao === 'Inclusao') {
                try {
                    resolve(r.data[0].Inclusao)
                }
                catch { resolve('N') }
            }

            if (opcao === 'Alteracao') {
                try {
                    resolve(r.data[0].Alteracao)
                }
                catch { resolve('N') }
            }

            if (opcao === 'Exclusao') {
                try {
                    resolve(r.data[0].Exclusao)
                }
                catch { resolve('N') }
            }

            // resolve(r.data)
        })
    })
}


api.getListData = async (table, parameter) => {
    return new Promise(async (resolve, reject) => {
        console.log('Searching for parameter ' + parameter)
        await api.get('/' + table + '/lista' + (parameter ? '/' + parameter : '')).then(async r => {
            console.log(r.data)
            resolve(r.data)
        })
    })
}

api.getImage = async (regName, pk, image) => {
    return new Promise(async (resolve, reject) => {
        if (pk && image) {
            axios.get(backendUrl + '/static/upload/fotos/' + regName + '/' + pk + '/' + image).then(r => {
                resolve(backendUrl + '/static/upload/fotos/' + regName + '/' + pk + '/' + image)
            }).catch(e => resolve(backendUrl + '/static/upload/no-image.jpg'))
        } else resolve(backendUrl + '/static/upload/no-image.jpg')
    })
}

api.getTipoDocumento = async (fk_mdl) => {
    return new Promise(async (resolve, reject) => {
        resolve(await api.getComboData('tipo_documento', fk_mdl))
    })
}

api.noImageUrl = backendUrl + '/static/upload/no-image.jpg'
api.backendUrl = backendUrl

export default api